import React from "react";
import { Button, Code, Group, Paper, Stack, Text } from "@mantine/core";
import { getApiBaseUrl } from "../utils";
import { MEDIA_ASSET_KEYS } from "@multiconsult-group/multiplacer-core";
import { FaDownload } from "react-icons/fa";
import HSpace from "../HSpace";

export const DownloadRevitPlugin: React.FC = () => {
  const key = MEDIA_ASSET_KEYS.REVIT_PLUGIN_INSTALLER;

  const downloadUrl = `${getApiBaseUrl()}/api/multiplacer/media-assets/${key}/download`;

  return (
    <Paper withBorder p="md">
      <Stack gap="xs">
        <Text fw={600}>Last ned</Text>

        <Text size="sm" c="dimmed">
          Last ned siste versjon av Revit-pluginet.
        </Text>

        <Group>
          <Button
            component="a"
            href={downloadUrl}
            target="_blank"
            rel="noopener noreferrer"
            variant="filled"
          >
            <FaDownload />
            <HSpace />
            Last ned siste
          </Button>
        </Group>
      </Stack>
    </Paper>
  );
};
